/**
 * Where OnboardingChat parks a signed-out setup conversation across the Auth0 round trip, so the
 * transcript, config and sub-flow stage survive the redirect and the wizard resumes on return.
 *
 */
export const PENDING_CHAT_PROJECT_KEY = 'loopqa-pending-chat-project'
